import * as Bixby from '$/core';

export abstract class CloService {
  private static baseUrl = Bixby.Constants.API_CLOCONTROLLER;

  // Client
  public static async getCloAnalytics(): Promise<Bixby.Models.CloAnalytics[]> {
    const route = Bixby.API.ServerRoute.forAction(`${CloService.baseUrl}/${Bixby.Constants.API_ACTION_CLO_ANALYTICS}`);
    return await Bixby.API.get(route);
  }

  public static async getDealCloAnalytics(): Promise<Bixby.Models.CloAnalytics[]> {
    const route = Bixby.API.ServerRoute.forAction(`${CloService.baseUrl}/${Bixby.Constants.API_ACTION_DEAL_CLO_ANALYTICS}`);
    return await Bixby.API.get(route);
  }

  public static async getCloAnalyticsById(cloId: string): Promise<Bixby.Models.CloAnalytics[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${CloService.baseUrl}/${Bixby.Constants.API_ACTION_CLO_INDUSTRIES}/${cloId}`
    );
    return await Bixby.API.get(route);
  }
  
  public static async getCloById(cloId: string): Promise<Bixby.Models.Clo> {
    const route = Bixby.API.ServerRoute.forAction(`${CloService.baseUrl}/${cloId}`);
    const results: Bixby.Models.Clo = await Bixby.API.get(route);
    return results;
  }

  public static async getSummaryAnalyticsById(cloId: string): Promise<Bixby.Models.CloAnalytics[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${CloService.baseUrl}/${Bixby.Constants.API_ACTION_CLO_ANALYTICS}/${cloId}`
    );
    return await Bixby.API.get(route);
  }

  public static async getSummaryAnalyticsByDate(closingDate: Date | undefined): Promise<Bixby.Models.CloAnalytics[]> {
    const route = Bixby.API.ServerRoute.forAction(
      `${CloService.baseUrl}/${Bixby.Constants.API_ACTION_CLO_ANALYTICS}/${closingDate}`
    );
    const results: Bixby.Models.CloAnalytics[] = await Bixby.API.get(route);
    return results;
  }

  public static async getAllClos(): Promise<Bixby.Models.CloSlim[]> {
    const route = Bixby.API.ServerRoute.forAction(`${Bixby.Constants.API_ADMIN_PREFIX}/${CloService.baseUrl}`);
    const results: Bixby.Models.CloSlim[] = await Bixby.API.get(route);
    return results;
  }

  public static async createClo(newClo: Bixby.Models.CreateCloRequest): Promise<Bixby.Models.Clo> {
    const route = Bixby.API.ServerRoute.forAction(`${Bixby.Constants.API_ADMIN_PREFIX}/${CloService.baseUrl}`);
    const result: Bixby.Models.Clo = await Bixby.API.post(route, newClo);
    return result;
  }

  public static async updateClo(updateRequest: Bixby.Models.CloSlim): Promise<Bixby.Models.Clo> {
    const route = Bixby.API.ServerRoute.forAction(
      `${Bixby.Constants.API_ADMIN_PREFIX}/${CloService.baseUrl}/${Bixby.Constants.API_ACTION_UPDATE}`
    );
    const result: Bixby.Models.Clo = await Bixby.API.post(route, updateRequest);
    return result;
  }

  public static async addClientClo(clientId: string, cloId: string) {
    const client = `${Bixby.Constants.API_CLIENTCONTROLLER}/${clientId}`;
    const clo = `${Bixby.Constants.API_ACTION_CLO}/${cloId}`;
    const route = Bixby.API.ServerRoute.forAction(`${Bixby.Constants.API_ADMIN_PREFIX}/${client}/${clo}`);
    return await Bixby.API.post(route, null);
  }

  public static async deleteClientClo(clientId: string, cloId: string) {
    const client = `${Bixby.Constants.API_CLIENTCONTROLLER}/${clientId}`;
    const clo = `${Bixby.Constants.API_ACTION_CLO}/${cloId}`;
    const route = Bixby.API.ServerRoute.forAction(`${Bixby.Constants.API_ADMIN_PREFIX}/${client}/${clo}`);
    return await Bixby.API.delete(route);
  }

  public static async uploadZipfile(cloId: string, file: File) {
    const url = `${Bixby.Constants.API_ADMIN_PREFIX}/${CloService.baseUrl}/${cloId}/${Bixby.Constants.API_ACTION_SUBMIT}`;
    const route = Bixby.API.ServerRoute.forAction(url);

    const formData = new FormData();
    formData.append('file', file);

    return await Bixby.API.postJSON(route, formData);
  }

  public static async downloadSFDRReportById(cloId: string) {
    const route = Bixby.API.ServerRoute.forAction(
      `${CloService.baseUrl}/${Bixby.Constants.API_ACTION_DOWNLOAD}/${Bixby.Constants.API_ACTION_CLO_SFDR_REPORT}/${cloId}`
    );

    const blob = await Bixby.API.getFileWithMetadata(route);
    
    return blob;
  }

  public static async downloadSfdrWhitePaper() {
    const route = Bixby.API.ServerRoute.forAction(
      `${CloService.baseUrl}/${Bixby.Constants.API_ACTION_DOWNLOAD}/${Bixby.Constants.API_ACTION_CLO_SFDR_WHITE_REPORT}`
    );

    const blob = await Bixby.API.getFileWithMetadata(route);
    
    return blob;
  }
}